import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "e-wallet-wrapper md:!tw-pb-16 md:!tw-box-border md:!tw-mt-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "md:!tw-text-base" }, "Workstation E-Wallet Account", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WalletTransactionsListComponent = _resolveComponent("WalletTransactionsListComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_WalletTransactionsListComponent)
  ]))
}